const image_swiper = new Swiper('.image-slider__swiper', {

	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	  },

	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	},

});

const swiper = new Swiper('.three-slides-slider', {
  loop: false,
	slidesPerView: 1,
	spaceBetween: 30,

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },

	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	},

	breakpoints: {
    768: {
      slidesPerView: 2,
    },
    991: {
      slidesPerView: 3,
    },
  }

});


const logos_swiper = new Swiper('.logos-slider__wrapper', {
  loop: false,
	slidesPerView: 2,
	spaceBetween: 30,

	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	  },

	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	},

	breakpoints: {
		
		991: {
		  slidesPerView: 5,
		},
	  }
});


